<template>
  <div>
    <el-dialog
      ref="dialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="550px"
      class="logindialog"
      >
      <div style="text-align: center;">
        <img src="../../assets/images/logo.png" alt="">
        <div v-if="loginTpye == 'login'" class="text-center">Login with password</div>
      </div>
      <div>
        <el-input style="margin: 40px 0 20px;" v-model="user.name" placeholder="Phone No./email"></el-input>
        <el-input v-model="user.password" placeholder="Please input password"></el-input>
        <div v-if="loginTpye == 'login'" class="retrieveouter">
          <span class="retrieve">forgot password</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button v-if="loginTpye == 'login'" class="btn2" @click="login">LOGIN</button>
        <button v-if="loginTpye == 'register'" class="btn2" @click="register">REGISTER</button>
         <div class="text-center" v-if="loginTpye == 'login'" style="margin:20px 0 40px;">
          <span>New to QIANYUANMAIL? </span><span @click="goRegister"class="register">Register</span>
         </div>
         <div class="text-center" v-if="loginTpye == 'register'" style="margin:20px 0 40px;">
          <span @click="goLogin"class="register">login with password</span>
         </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'newArrival',
  data() {
    return {
      dialogVisible: false,
      loginTpye: 'login', //register
      user: {
        name: '',
        password: ''
      }
    };
  },
  methods: {
    show () {
      this.dialogVisible = true
    },
    hide () {
      this.dialogVisible = false
    },
    login () {
    },
    register () {
    },
    goRegister () {
      this.loginTpye = 'register'
      this.user.name = ''
      this.user.password = ''
    },
    goLogin () {
      this.loginTpye = 'login'
      this.user.name = ''
      this.user.password = ''
    }
  }
}
</script>

<style lang="less" scoped>
.logindialog {
  padding: 30px 10px;
}
.btn2 {
  width: 100%;
  background: linear-gradient(90deg,#f76900 -107.28%,#dd3131);
  border: 1px solid #dd3131;
  color: #fff;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
}
.retrieveouter {
  text-align: right;
  margin: 10px 0 0 0;
  color: red;
  cursor: pointer;
}
.retrieve {
  border-bottom: 1px solid red;
}
.register {
  color: red;
  border-bottom: 1px solid red;
  cursor: pointer;
}
</style>